import * as requestFromServer from "./referralCodesApis";


// referral codes -> update service provider referral codes api
export const updateServiceProviderReferralCodeAction = (setLoading, dataToBeSent) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.updateServiceProviderReferralCode(dataToBeSent);
    if (response) {
      setLoading(false);
      return response;
    }
    else {
      setLoading(false)
      return null
    }
};

// referral codes -> update customer referral codes api
export const updateCustomerReferralCodeAction = (setLoading, dataToBeSent) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.updateCustomerReferralCode(dataToBeSent);
    if (response) {
      setLoading(false);
      return response;
    }
    else {
      setLoading(false)
      return null
    }
};